import Vue from 'vue'

function confirmation(message, type = 'success', callback = null) {
    Vue.prototype.$swal({
        icon: type,
        title: message,
        confirmButtonText: 'Aceptar',
        showCancelButton: false,
        focusCancel: false,
        reverseButtons: false,
        customClass: {
            confirmButton: 'button button--yellow',
            title: 'text-strong text-big text-black pb-4 pt-3'
        }
    }).then((result) => {
        if (result.isConfirmed && typeof callback === 'function') {
            callback();
        }
    });
}

function notify(message) {
    Vue.prototype.$swal({
        icon: 'warning',
        title: message,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusCancel: false,
        customClass: {}
    })
}

export const notifications = {
    notify,
    confirmation
}

export default notifications
